// Interpreter Licensure Requirements by State
// Based on December 10, 2025 research and implementation

export const interpreterLicensureRequirements = {
  // Comprehensive state interpreter licensure requirements
  // Recovered from December 10, 2025 implementation
  
  arizona: {
    state: 'Arizona',
    hasLicensure: true,
    sourceUrl: 'https://www.acdhh.org',
    notes: 'Multiple license types with different requirements. Audited every 5 years.',
    licenses: [
      {
        id: 'az-general',
        name: 'General',
        requirements: 'Maintain RID/NAD/BEI certification',
        auditCycle: '5 years',
        ceuRequirements: 'Maintain RID/NAD/BEI certification',
        renewalPeriod: 'Annual',
        fee: 125,
        renewalFee: 50
      },
      {
        id: 'az-legal-a',
        name: 'Legal A',
        requirements: 'Maintain SC:L or BEI CIC certification',
        auditCycle: '5 years',
        ceuRequirements: 'Maintain SC:L or BEI CIC certification',
        renewalPeriod: 'Annual',
        fee: 125,
        renewalFee: 50
      },
      {
        id: 'az-legal-c',
        name: 'Legal C',
        requirements: 'Maintain certification + 20 hours legal CEUs per cycle',
        auditCycle: '5 years',
        ceuRequirements: 'Maintain certification + 20 hours legal CEUs per cycle',
        renewalPeriod: 'Annual',
        fee: 125,
        renewalFee: 50
      },
      {
        id: 'az-legal-d',
        name: 'Legal D',
        requirements: 'Maintain certification + 20 hours legal CEUs per cycle',
        auditCycle: '5 years',
        ceuRequirements: 'Maintain certification + 20 hours legal CEUs per cycle',
        renewalPeriod: 'Annual',
        fee: 125,
        renewalFee: 50
      },
      {
        id: 'az-provisional',
        name: 'Provisional A/B/C/D',
        requirements: '12 hours annually + teaming journal',
        auditCycle: 'Annual',
        ceuRequirements: '12 hours annually + teaming journal',
        renewalPeriod: 'Annual',
        fee: 25,
        renewalFee: 25
      }
    ]
  },



  utah: {
    state: 'Utah',
    hasLicensure: true,
    sourceUrl: 'https://jobs.utah.gov/usor/uip/',
    notes: 'Detailed CEH tracking system. RID certified have simplest path.',
    initialFee: 70,
    renewalFee: 50,
    licenses: [
      {
        id: 'ut-rid-certified',
        name: 'RID Certified',
        requirements: 'Maintain current RID certification',
        auditCycle: 'Follow RID cycle',
        ceuRequirements: 'Maintain current RID certification',
        renewalPeriod: 'Follow RID cycle'
      },
      {
        id: 'ut-ucni-eipa',
        name: 'UCNI/EIPA',
        requirements: '20 CEH annually (90% Professional Studies)',
        auditCycle: 'Annual',
        ceuRequirements: '20 CEH annually (90% Professional Studies)',
        renewalPeriod: 'Annual'
      },
      {
        id: 'ut-ucpi-ucmi-ucdi',
        name: 'UCPI/UCMI/UCDI',
        requirements: '80 CEH per 4 years (90% Professional Studies)',
        auditCycle: '4 years',
        ceuRequirements: '80 CEH per 4 years (90% Professional Studies)',
        renewalPeriod: '4 years'
      }
    ]
  },

  kentucky: {
    state: 'Kentucky',
    hasLicensure: true,
    sourceUrl: 'https://oop.ky.gov/active_lic_dir.aspx',
    notes: 'Can carry over 6 excess hours (Full License only)',
    initialFee: 175,
    renewalFee: 125,
    licenses: [
      {
        id: 'ky-full-license',
        name: 'Full License',
        requirements: '15 hours (7.5 approved sources, 3 ethics)',
        auditCycle: 'Annual',
        ceuRequirements: '15 hours (7.5 approved sources, 3 ethics)',
        renewalPeriod: 'Annual',
        carryOver: '6 hours'
      },
      {
        id: 'ky-temporary-license',
        name: 'Temporary License',
        requirements: '18 hours (7.5 approved sources, 3 ethics)',
        auditCycle: 'Annual',
        ceuRequirements: '18 hours (7.5 approved sources, 3 ethics)',
        renewalPeriod: 'Annual'
      }
    ]
  },

  maine: {
    state: 'Maine',
    hasLicensure: true,
    sourceUrl: 'https://licensing.web.maine.gov',
    notes: 'Certified interpreters just maintain RID. Conditional max 4 years (5th with hardship).',
    initialFee: 200,
    renewalFee: 200,
    licenses: [
      {
        id: 'me-certified',
        name: 'Certified',
        requirements: 'Maintain RID registration only',
        auditCycle: 'Follow RID cycle',
        ceuRequirements: 'Maintain RID registration only',
        renewalPeriod: 'Follow RID cycle'
      },
      {
        id: 'me-conditional',
        name: 'Conditional',
        requirements: '20 hours per renewal (10 for first renewal)',
        auditCycle: 'Annual',
        ceuRequirements: '20 hours per renewal (10 for first renewal)',
        renewalPeriod: 'Annual',
        maxYears: 4
      }
    ]
  },

  michigan: {
    state: 'Michigan',
    hasLicensure: true,
    sourceUrl: 'https://interpreter.apps.lara.state.mi.us/',
    notes: '4-year cycle tracked manually by state',
    initialFee: 30,
    renewalFee: 30,
    licenses: [
      {
        id: 'mi-rid-certified',
        name: 'RID Certified',
        requirements: 'Maintain RID certification',
        auditCycle: '4 years',
        ceuRequirements: 'Maintain RID certification',
        renewalPeriod: '4 years'
      },
      {
        id: 'mi-eipa-certified',
        name: 'EIPA Certified',
        requirements: '20 hours annually with Ethics/PPO',
        auditCycle: 'Annual',
        ceuRequirements: '20 hours annually with Ethics/PPO',
        renewalPeriod: 'Annual'
      },
      {
        id: 'mi-bei-certified',
        name: 'BEI Certified',
        requirements: '20 hours annually with Ethics/PPO',
        auditCycle: 'Annual',
        ceuRequirements: '20 hours annually with Ethics/PPO',
        renewalPeriod: 'Annual'
      }
    ]
  },

  missouri: {
    state: 'Missouri',
    hasLicensure: true,
    sourceUrl: 'https://pr.mo.gov/interpreters.asp',
    notes: 'CEU requirements need crowdsourcing',
    initialFee: 60,
    renewalFee: 60,
    licenses: [
      {
        id: 'mo-license',
        name: 'License',
        requirements: 'State certification required',
        auditCycle: 'Annual',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Annual'
      }
    ]
  },

  alabama: {
    state: 'Alabama',
    hasLicensure: true,
    sourceUrl: 'https://albit.alabama.gov',
    notes: 'Licensees can follow RID CMP or state annual requirement',
    initialFee: 225,
    renewalFee: 175,
    licenses: [
      {
        id: 'al-license',
        name: 'License',
        requirements: 'Follow RID CMP or state annual requirement',
        auditCycle: 'Annual',
        ceuRequirements: 'Follow RID CMP or state annual requirement',
        renewalPeriod: 'Annual'
      }
    ]
  },

  texas: {
    state: 'Texas',
    hasLicensure: true,
    sourceUrl: 'https://www.hh.texas.gov',
    notes: 'BEI certification specifically required. Follow BEI CMP requirements.',
    initialFee: 75,
    renewalFee: 75,
    licenses: [
      {
        id: 'tx-bei-required',
        name: 'BEI Certification Required',
        requirements: 'BEI certification specifically required',
        auditCycle: 'Follow BEI cycle',
        ceuRequirements: 'Follow BEI CMP requirements',
        renewalPeriod: 'Follow BEI cycle'
      }
    ]
  },

  arkansas: {
    state: 'Arkansas',
    hasLicensure: true,
    sourceUrl: 'https://healthy.arkansas.gov/boards-commissions/boards/interpreters-for-the-deaf-advisory-board/',
    notes: 'No CEU requirements found - needs crowdsourcing',
    initialFee: 5,
    renewalFee: 4,
    licenses: [
      {
        id: 'ar-license',
        name: 'License',
        requirements: 'No CEU requirements found',
        auditCycle: 'Unknown',
        ceuRequirements: 'No CEU requirements found - needs crowdsourcing',
        renewalPeriod: 'Annual'
      }
    ]
  },

  newhampshire: {
    state: 'New Hampshire',
    hasLicensure: true,
    sourceUrl: 'https://www.education.nh.gov',
    notes: 'CEU requirements need crowdsourcing',
    initialFee: 150,
    renewalFee: 175,
    licenses: [
      {
        id: 'nh-license',
        name: 'License',
        requirements: 'CEU requirements need crowdsourcing',
        auditCycle: 'Unknown',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Annual'
      }
    ]
  },

  idaho: {
    state: 'Idaho',
    hasLicensure: true,
    sourceUrl: 'https://apps.dopl.idaho.gov/DOPLPublic/LPRBrowser.aspx',
    notes: 'Simple annual requirement. Can be concurrent with RID CEUs.',
    initialFee: 70,
    renewalFee: 70,
    licenses: [
      {
        id: 'id-license',
        name: 'License',
        requirements: 'Simple annual requirement',
        auditCycle: 'Annual',
        ceuRequirements: 'Can be concurrent with RID CEUs',
        renewalPeriod: 'Annual'
      }
    ]
  },

  delaware: {
    state: 'Delaware',
    hasLicensure: true,
    sourceUrl: 'https://legis.delaware.gov/BillDetail/89292',
    notes: 'Registration Act passed but CEU requirements not yet defined',
    initialFee: 100,
    renewalFee: 100,
    licenses: [
      {
        id: 'de-registration-pending',
        name: 'Registration (Pending)',
        requirements: 'CEU requirements not yet defined',
        auditCycle: 'TBD',
        ceuRequirements: 'CEU requirements not yet defined',
        renewalPeriod: 'TBD'
      }
    ]
  },

  newmexico: {
    state: 'New Mexico',
    hasLicensure: true,
    sourceUrl: 'http://verification.rld.state.nm.us/Search.aspx?facility=N',
    notes: 'CEU requirements need crowdsourcing',
    initialFee: 65,
    renewalFee: 50,
    licenses: [
      {
        id: 'nm-license',
        name: 'License',
        requirements: 'CEU requirements need crowdsourcing',
        auditCycle: 'Unknown',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Annual'
      }
    ]
  },

  nebraska: {
    state: 'Nebraska',
    hasLicensure: true,
    sourceUrl: 'https://ncdhh.nebraska.gov/',
    notes: 'CEU requirements need crowdsourcing',
    initialFee: 150,
    renewalFee: 150,
    licenses: [
      {
        id: 'ne-license',
        name: 'License',
        requirements: 'CEU requirements need crowdsourcing',
        auditCycle: 'Unknown',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Annual'
      }
    ]
  },

  northcarolina: {
    state: 'North Carolina',
    hasLicensure: true,
    sourceUrl: 'https://ncitlb.org/current-licensees/',
    notes: 'Established 12/01/2023. CEU requirements need crowdsourcing.',
    initialFee: 225,
    renewalFee: 150,
    licenses: [
      {
        id: 'nc-license',
        name: 'License',
        requirements: 'CEU requirements need crowdsourcing',
        auditCycle: 'Unknown',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Annual'
      }
    ]
  },

  iowa: {
    state: 'Iowa',
    hasLicensure: true,
    sourceUrl: 'https://amanda-portal.idph.state.ia.us/ibpl/portal/',
    notes: 'First renewal: No CEU requirement',
    initialFee: 120,
    licenses: [
      {
        id: 'ia-license',
        name: 'License',
        requirements: 'First renewal: No CEU requirement',
        auditCycle: 'Annual',
        ceuRequirements: 'First renewal: No CEU requirement',
        renewalPeriod: 'Annual'
      }
    ]
  },

  illinois: {
    state: 'Illinois',
    hasLicensure: true,
    sourceUrl: 'https://www2.illinois.gov/idhhc/licensure/',
    notes: 'No distinction between Professional and General Studies',
    initialFee: 175,
    renewalFee: 150,
    licenses: [
      {
        id: 'il-license',
        name: 'License',
        requirements: 'No distinction between Professional and General Studies',
        auditCycle: 'Annual',
        ceuRequirements: 'No distinction between Professional and General Studies',
        renewalPeriod: 'Annual'
      }
    ]
  },

  nevada: {
    state: 'Nevada',
    hasLicensure: true,
    hasRegistry: true,
    sourceUrl: 'https://nvir.certemy.com/public-registry/1bd856a7-477b-4d87-89d5-a1f8d84703cf',
    notes: 'Registration system - proof of certification required. No fees.',
    initialFee: 0,
    renewalFee: 0,
    licenses: [
      {
        id: 'nv-registration',
        name: 'Registration',
        requirements: 'Proof of national certification required',
        auditCycle: 'Unknown',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Unknown'
      }
    ]
  },

  rhodeisland: {
    state: 'Rhode Island',
    hasLicensure: true,
    sourceUrl: 'https://www.health.RI.gov',
    notes: 'Minimum bachelor\'s degree required. Board of 3 certified interpreters and 2 consumers.',
    initialFee: 50,
    renewalFee: 50,
    licenses: [
      {
        id: 'ri-certified',
        name: 'Certified License',
        requirements: 'Bachelor\'s degree + RID/NAD certification',
        auditCycle: 'Annual',
        ceuRequirements: 'Follow RID/NAD certification maintenance',
        renewalPeriod: 'Annual'
      },
      {
        id: 'ri-screened',
        name: 'Screened License of Limited Duration',
        requirements: 'State screening assessment',
        auditCycle: 'Annual',
        ceuRequirements: 'State screening requirements',
        renewalPeriod: 'Limited duration'
      }
    ]
  },

  indiana: {
    state: 'Indiana',
    hasLicensure: true,
    sourceUrl: 'https://www.in.gov/fssa/ddrs/',
    notes: 'Board of Interpreter Standards. 5-year provisional licensure available.',
    initialFee: 50,
    renewalFee: 50,
    licenses: [
      {
        id: 'in-license',
        name: 'License',
        requirements: 'RID or NAD certification',
        auditCycle: 'Annual',
        ceuRequirements: 'Maintain RID/NAD certification',
        renewalPeriod: 'Annual'
      },
      {
        id: 'in-provisional',
        name: '5-Year Provisional License',
        requirements: 'Working toward certification',
        auditCycle: 'Annual',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Annual',
        maxYears: 5
      }
    ]
  },

  hawaii: {
    state: 'Hawaii',
    hasLicensure: true,
    sourceUrl: 'https://www.courts.state.hi.us',
    notes: 'Established 2007. Overseen by Supreme Court and Administration Director.',
    initialFee: null, // Unknown
    renewalFee: null, // Unknown
    licenses: [
      {
        id: 'hi-license',
        name: 'License',
        requirements: 'RID certification accepted',
        auditCycle: 'Unknown',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Unknown'
      }
    ]
  },

  mississippi: {
    state: 'Mississippi',
    hasLicensure: true,
    hasRegistry: true,
    sourceUrl: 'https://www.odhh.org/interpreter-registration/',
    notes: 'Registration system (not full license). 2-year renewable registration.',
    initialFee: 25,
    renewalFee: 100, // Up to $100 per annual registration
    licenses: [
      {
        id: 'ms-registration',
        name: 'Registration',
        requirements: 'NAD/RID certification, ODHH QA screening, or EIPA 3.0+',
        auditCycle: '2 years',
        ceuRequirements: 'Follow underlying certification requirements',
        renewalPeriod: '2 years'
      },
      {
        id: 'ms-student-level',
        name: 'Student Level Registration',
        requirements: 'ITP graduates with supervision for up to 2 years',
        auditCycle: '2 years',
        ceuRequirements: 'Supervised practice requirements',
        renewalPeriod: '2 years',
        maxYears: 2
      }
    ]
  },

  wisconsin: {
    state: 'Wisconsin',
    hasLicensure: true,
    sourceUrl: 'https://www.wicourts.gov',
    notes: 'Wisconsin Administrative Code SPS 201.01(25) requires DSPS interpreters to comply with continuing education requirements of their underlying certification (RID/NAD/BEI). Separate requirements for spoken language vs ASL interpreters.',
    initialFee: 75,
    renewalFee: 60,
    licenses: [
      {
        id: 'wi-dsps-advanced-hearing',
        name: 'DSPS Advanced ASL (Hearing)',
        requirements: 'Must comply with RID/NAD continuing education requirements',
        auditCycle: '2 years',
        ceuRequirements: 'Must comply with RID/NAD continuing education requirements (SPS 201.01(25))',
        renewalPeriod: 'August 31, odd years',
        fee: 75,
        legalReference: 'Wisconsin Administrative Code SPS 201.01(25)'
      },
      {
        id: 'wi-dsps-advanced-deaf',
        name: 'DSPS Advanced ASL (Deaf)',
        requirements: 'Must comply with RID/NAD continuing education requirements',
        auditCycle: '2 years',
        ceuRequirements: 'Must comply with RID/NAD continuing education requirements (SPS 201.01(25))',
        renewalPeriod: 'August 31, odd years',
        fee: 75,
        legalReference: 'Wisconsin Administrative Code SPS 201.01(25)'
      },
      {
        id: 'wi-dsps-provisional-hearing',
        name: 'DSPS Provisional ASL (Hearing)',
        requirements: '1.6 credits per 2-year period including legal topics',
        auditCycle: '2 years',
        ceuRequirements: '1.6 credits per 2-year period (must include legal topics)',
        renewalPeriod: 'October 1, even years',
        fee: 75
      },
      {
        id: 'wi-dsps-provisional-deaf',
        name: 'DSPS Provisional ASL (Deaf)',
        requirements: '1.0 credit per 2-year period including legal topics',
        auditCycle: '2 years',
        ceuRequirements: '1.0 credit per 2-year period (must include legal topics)',
        renewalPeriod: 'October 1, even years',
        fee: 75
      }
    ]
  },

  colorado: {
    state: 'Colorado',
    hasLicensure: false,
    hasRegistry: true,
    sourceUrl: 'N/A',
    notes: 'No state licensure requirements - certification recognition only',
    initialFee: 0,
    renewalFee: 0,
    licenses: [
      {
        id: 'co-recognition',
        name: 'Certification Recognition',
        requirements: 'No additional state requirements beyond national certification',
        auditCycle: 'N/A',
        ceuRequirements: 'Follow national certification requirements (RID/BEI)',
        renewalPeriod: 'N/A'
      }
    ]
  },

  southcarolina: {
    state: 'South Carolina',
    hasLicensure: true,
    sourceUrl: 'https://www.scstatehouse.gov',
    notes: 'Sign Language Interpreters Act effective January 1, 2023. Legal and educational interpreters have specific requirements.',
    initialFee: null, // Unknown
    renewalFee: null, // Unknown
    licenses: [
      {
        id: 'sc-legal',
        name: 'Legal Interpreter',
        requirements: 'Nationally recognized certifications required',
        auditCycle: 'Unknown',
        ceuRequirements: 'Follow national certification requirements',
        renewalPeriod: 'Unknown'
      },
      {
        id: 'sc-educational',
        name: 'Educational Interpreter',
        requirements: 'EIPA 3.5 or higher required',
        auditCycle: 'Unknown',
        ceuRequirements: 'Maintain EIPA certification',
        renewalPeriod: 'Unknown'
      }
    ]
  },

  southdakota: {
    state: 'South Dakota',
    hasLicensure: true,
    hasRegistry: true,
    sourceUrl: 'https://dhs.sd.gov',
    notes: 'Registration system established 2006',
    initialFee: 50,
    renewalFee: 35,
    licenses: [
      {
        id: 'sd-national-registration',
        name: 'National Registration',
        requirements: 'South Dakota Certification Level III, IV, V, RID, NAD, or EIPA 3.5+',
        auditCycle: 'Annual',
        ceuRequirements: 'Maintain underlying certification',
        renewalPeriod: 'Annual'
      },
      {
        id: 'sd-provisional',
        name: 'Provisional Certification',
        requirements: 'Working toward national certification',
        auditCycle: 'Annual',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Annual',
        fee: 250,
        renewalFee: 35
      }
    ]
  },

  // States with no known licensure requirements (most common)
  california: {
    state: 'California',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  newyork: {
    state: 'New York',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  florida: {
    state: 'Florida',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  pennsylvania: {
    state: 'Pennsylvania',
    hasLicensure: true,
    hasRegistry: true,
    sourceUrl: 'https://www.legis.state.pa.us',
    notes: 'State registration system (not full license). Biennial renewal.',
    initialFee: 100,
    renewalFee: 50,
    licenses: [
      {
        id: 'pa-registration',
        name: 'State Registration',
        requirements: 'Required for all interpreters',
        auditCycle: '2 years',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: '2 years'
      },
      {
        id: 'pa-provisional',
        name: 'Provisional Registration',
        requirements: 'Recent IEP graduates, eligible for RID performance test',
        auditCycle: '2 years',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: '2 years',
        fee: 50
      }
    ]
  },

  ohio: {
    state: 'Ohio',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No general licensure. Educational interpreters may need state certification.',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  georgia: {
    state: 'Georgia',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  northdakota: {
    state: 'North Dakota',
    hasLicensure: false,
    hasRegistry: true,
    sourceUrl: 'N/A',
    notes: 'Proof of certification required (not registration or licensure). No additional state requirements.',
    initialFee: 0,
    renewalFee: 0,
    licenses: [
      {
        id: 'nd-certification-proof',
        name: 'Certification Proof Required',
        requirements: 'Must hold valid RID or NAD certification',
        auditCycle: 'N/A',
        ceuRequirements: 'Follow national certification requirements',
        renewalPeriod: 'N/A'
      }
    ]
  },

  westvirginia: {
    state: 'West Virginia',
    hasLicensure: true,
    hasRegistry: true,
    sourceUrl: 'https://www.dhhr.wv.gov',
    notes: 'West Virginia Registry of Interpreters (WVRI). Must maintain RID membership.',
    initialFee: 25,
    renewalFee: 0,
    licenses: [
      {
        id: 'wv-nationally-certified',
        name: 'Nationally Certified',
        requirements: 'RID certification + maintain RID membership',
        auditCycle: '3 years',
        ceuRequirements: 'Follow RID CMP requirements',
        renewalPeriod: '3 years'
      },
      {
        id: 'wv-state-qualified',
        name: 'State Qualified',
        requirements: 'Valid credential from another state (e.g., VQAS)',
        auditCycle: '3 years',
        ceuRequirements: 'Follow RID CMP requirements',
        renewalPeriod: '3 years'
      }
    ]
  },

  // Additional states with no known requirements
  washington: {
    state: 'Washington',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  oregon: {
    state: 'Oregon',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No general licensure. Healthcare interpreter certification exists for publicly-funded providers only.',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  virginia: {
    state: 'Virginia',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  tennessee: {
    state: 'Tennessee',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  minnesota: {
    state: 'Minnesota',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  // Additional states to ensure complete coverage
  alaska: {
    state: 'Alaska',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  connecticut: {
    state: 'Connecticut',
    hasLicensure: false,
    hasRegistry: true,
    sourceUrl: 'https://portal.ct.gov/ads/knowledge-base/articles/accessibility-services/general-accessibility-services/deaf-and-hard-of-hearing-interpreter-registry',
    notes: 'Registry system only - no additional CEU requirements beyond maintaining certification',
    initialFee: 0,
    renewalFee: 0,
    licenses: [
      {
        id: 'ct-registry',
        name: 'State Registry',
        requirements: 'Annual registration required',
        auditCycle: 'N/A',
        ceuRequirements: 'No additional requirements beyond national certification',
        renewalPeriod: 'Annual (October 1 - September 30)'
      }
    ]
  },

  kansas: {
    state: 'Kansas',
    hasLicensure: false,
    hasRegistry: true,
    sourceUrl: 'https://kcdhh.ks.gov/communication-services/interpreting-services',
    notes: 'Registration system - transitioned from KQAS certification to registration in 2014',
    initialFee: 0,
    renewalFee: 0,
    licenses: [
      {
        id: 'ks-registration',
        name: 'State Registration',
        requirements: 'National certification/credentials recognized',
        auditCycle: 'Unknown',
        ceuRequirements: 'CEU requirements need crowdsourcing',
        renewalPeriod: 'Unknown'
      }
    ]
  },

  louisiana: {
    state: 'Louisiana',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  maryland: {
    state: 'Maryland',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  massachusetts: {
    state: 'Massachusetts',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  montana: {
    state: 'Montana',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  newjersey: {
    state: 'New Jersey',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  oklahoma: {
    state: 'Oklahoma',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  vermont: {
    state: 'Vermont',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  wyoming: {
    state: 'Wyoming',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  },

  districtofcolumbia: {
    state: 'District of Columbia',
    hasLicensure: false,
    hasRegistry: false,
    sourceUrl: 'N/A',
    notes: 'No state licensure or registration requirements found',
    initialFee: 0,
    renewalFee: 0,
    licenses: []
  }
};

// Helper functions
export const getStateRequirements = (state) => {
  const stateKey = state.toLowerCase().replace(/\s+/g, '');
  return interpreterLicensureRequirements[stateKey] || null;
};

export const hasStateLicensure = (state) => {
  const requirements = getStateRequirements(state);
  return requirements?.hasLicensure || false;
};

export const getStateLicenses = (state) => {
  const requirements = getStateRequirements(state);
  return requirements?.licenses || [];
};

export const getAllStatesWithLicensure = () => {
  return Object.values(interpreterLicensureRequirements)
    .filter(state => state.hasLicensure || state.hasRegistry)
    .map(state => state.state);
};

export const getAllStates = () => {
  // All 50 states + DC + territories, including those without requirements
  const allStates = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
    'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
    'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
    'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
    'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
    'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
    'Wisconsin', 'Wyoming', 'District of Columbia'
  ];
  
  return allStates;
};

export const getStateStatus = (stateName) => {
  const stateKey = stateName.toLowerCase().replace(/\s+/g, '').replace(/\./g, '');
  const stateData = interpreterLicensureRequirements[stateKey];
  
  if (!stateData) {
    return {
      hasData: false,
      hasLicensure: false,
      hasRegistry: false,
      message: `We don't have information about ${stateName} interpreter requirements yet.`
    };
  }
  
  return {
    hasData: true,
    hasLicensure: stateData.hasLicensure,
    hasRegistry: stateData.hasRegistry,
    licenses: stateData.licenses || [],
    message: stateData.hasLicensure || stateData.hasRegistry 
      ? `${stateName} has interpreter requirements.`
      : `${stateName} appears to have no interpreter licensure requirements.`
  };
};

export default interpreterLicensureRequirements;